<template>
<div class='vx-col w-full'> 
    <!-- tipo_accion{{ tipo_accion }} -->
    <div class="botonera-navegacion-juego" v-if="codigo_creado">
        <!-- <vs-button class="m-2" :type="op_show == 1 ? 'filled' : 'border'" color="dark" @click="op_show=1">Cabecera</vs-button>
        <vs-button class="m-2" :type="op_show == 2 ? 'filled' : 'border'" color="primary" @click="op_show=2">Opciones</vs-button>
        <vs-button class="m-2" :type="op_show == 3 ? 'filled' : 'border'" color="success" @click="op_show=3">Previsualizar</vs-button> -->
        <Botonera @getClicked_botonera="getClicked_botonera" :botonera_juego="botonera_juego" />
    </div>
    <div class="cabecera-juego" v-if="op_show==1">
        <!-- datos_tipo_juego_select EMPAREJAR {{ datos_tipo_juego_select }} -->
        <transition name="fade" mode="out-in">
            <CabeceraJuego v-if="op_cargar" @getCodigo="getCodigo" :datos_editar="datos_editar_columnas" :tipo_accion="tipo_accion" :datos_tipo_juego_select="datos_tipo_juego_select" />
        </transition>
    </div>
    <div class="opciones" v-if="op_show==2">
        <transition name="fade" mode="out-in">
            <Opciones_emparejar v-if="codigo_creado" :datos_editar="datos_editar_columnas" />
        </transition>
    </div>
    <div class="game-columnas" v-if="op_show==3">
        <transition name="fade" mode="out-in">
            <GameEmparejar v-if="codigo_creado" :datos_editar="datos_editar_columnas" />
        </transition>
    </div>
</div>
</template>

<script>
import GeneralMixin from '@/mixins/GeneralMixin';
import CabeceraJuego from '../cabeceraJuego.vue';
import Opciones_emparejar from './opciones_emparejar.vue';
import GameEmparejar from './emparejar.vue';
import Botonera from '../componentes/botonera.vue';
export default {
    props: {
        datos_editar: {
            type: Object,
            default: function () {
                return {};
            },
        },
        tipo_accion: {
            type: Number,
            default: function () {
                return 0;
            },
        },
        datos_tipo_juego_select: {
            type: Object,
            default: function () {
                return {};
            },
        },
    },
    mixins: [GeneralMixin],
    components: {
        CabeceraJuego,
        Opciones_emparejar,
        GameEmparejar,
        Botonera,
    },
    data() {
        return {
            codigo_creado: false,
            op_show: 1,
            op_cargar: false,
            datos_editar_columnas: {},
            botonera_juego:{
                cabecera:true,
                opciones:true,
                previsualizar:true,
            }
        };
    },
    created() {},
    mounted() {
        let me = this;
        me.op_cargar = false;
        me.f_iniciar();
    },
    methods: {
        f_iniciar() {
            let me = this;
            me.op_cargar = true;
            // console.log('datos_editar admin emparejar', me.datos_editar)
            if (me.tipo_accion == 1) { //editar juego
                me.datos_editar_columnas = me.datos_editar;
            }
            if (me.datos_editar.codigo != "" && me.datos_editar.codigo != null) {
                me.codigo_creado = true;
                // console.log('CODIGO CREADito==> ', me.codigo_creado, me.datos_editar_columnas)
            }
        },
        getCodigo(e) {
            let me = this;
            // console.log('get codigo en dmin emparejar', e);
            me.datos_editar_columnas = e;
            if (e) {
                me.codigo_creado = true;
                // me.dato_cabecera = true;
                // me.btn_cancelar = true;
                me.$emit('get_listar_juegos',e)
            }
        },
        getClicked_botonera(e) {
            let me = this;
            me.op_show = e;
            // console.log('getClicked_botonera', e);
        }
    }
};
</script>
